<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Beleggingen
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het gaat hier om:
                <li class="list">aandelen</li>
                <li class="list">obligaties</li>
                <li class="list">winstbewijzen</li>
                <li class="list">opties die niet bij een aanmerkelijk belang horen</li>
                <li class="list">aandelen in beleggingsfondsen</li>
                <div class="space10"></div>

                <b>Waarde beleggingen</b><br>
                Heb je aandelen, obligaties, winstbewijzen, opties of aandelen in beleggingsfondsen die genoteerd waren
                aan de effectenbeurs Euronext in Amsterdam? Geef dan de slotwaarden aan uit de Officiële Prijscourant
                die is uitgegeven door Euronext Amsterdam N.V. op de peildatum. Op 1 januari {{ this.year }} is dat de slotwaarde
                over {{ this.year - 1 }}.
                <div class="space10"></div>

                Waren de effecten niet genoteerd aan de effectenbeurs? Dan vermeld je de waarde in het economisch
                verkeer op 1 januari {{ this.year - 1 }}.

                <div class="space10"></div>
                <b>Negatief saldo</b><br/>
                Is het saldo van de belegging op 1 januari {{ this.year }} negatief? Dan vul je deze belegging in bij de schulden in box 3.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Groene beleggingen
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Groene beleggingen zijn beleggingen in beleggingsfondsen die door de Belastingdienst zijn erkend en die
                investeren in groene projecten zoals windturbines en zonnepanelen. Op <a target="_blank"
                                                                                         href="https://www.rvo.nl">rvo.nl</a>
                staat een overzicht van groene investeringen met belastingvoordeel. Staat je belegging hierbij? Dan hebt
                je recht op vrijstelling en heffingskorting voor deze groene investering.
            </div>
        </div>
    </div>

</div>


